module.exports = __webpack_public_path__ + "static/img/kjcz.11714c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kjcz.png
// module id = JAu5
// module chunks = 1